import { supabase } from '../../lib/supabase';
export type { SaasMarketingPathConfig, SaasMarketingPathKey } from './saasMarketingPathsCore.js';
export {
  DEFAULT_SAAS_MARKETING_PATHS,
  mergeSaasMarketingPathConfig,
  parseOrgMarketingPathsFromBranding,
  parseSaasMarketingPathConfig,
} from './saasMarketingPathsCore.js';

import type { SaasMarketingPathConfig, SaasMarketingPathKey } from './saasMarketingPathsCore.js';
import { DEFAULT_SAAS_MARKETING_PATHS, parseSaasMarketingPathConfig } from './saasMarketingPathsCore.js';

let runtimeMarketingPaths: Record<SaasMarketingPathKey, string> | null = null;

export function setRuntimeTenantMarketingPaths(paths: Record<SaasMarketingPathKey, string> | null): void {
  runtimeMarketingPaths = paths;
}

export function getRuntimeTenantMarketingPaths(): Record<SaasMarketingPathKey, string> {
  return runtimeMarketingPaths ?? DEFAULT_SAAS_MARKETING_PATHS;
}

export async function fetchSaasMarketingPathDefaults(): Promise<SaasMarketingPathConfig> {
  const { data } = await supabase
    .from('app_config')
    .select('value')
    .eq('key', 'saas_marketing_paths')
    .maybeSingle();
  return parseSaasMarketingPathConfig(data?.value);
}
